import { makeStyles } from "@material-ui/core/styles";

export const NewStyledModalStyles = makeStyles((theme) => {
  return ({
    titleWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    modalTitle: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      margin: 0,
    },
    closeIcon: {
      color: theme.palette.grey["700"],
    },
    separator: {
      paddingBottom: "1rem",
    },
    modalBody: {
      backgroundColor: theme.palette.grey["200"],
      borderBottom: `solid 1px ${theme.palette.grey["400"]}`,
      borderRadius: "4px 4px 0px 0px",
      padding: "0.5rem",
    },
    modalBodyWrapper: {
      paddingInline: "1rem",
      paddingBottom: "1rem"
    }
  });
});
